// extracted by mini-css-extract-plugin
module.exports = {"title":"_9748a44","button":"_76be103"};